export const timeZoneConstants = {
	UTC: 'Etc/UTC',
	PACIFIC: 'America/Los_Angeles',
	JAPAN: 'Asia/Tokyo',
	LOCAL: Intl.DateTimeFormat().resolvedOptions().timeZone
};
